<div class="filter-popup p-1">
  <div class="row mb-2" *ngIf="filterType === 'payment-sts' || filterType === 'status'">
    <div class="col">
      <span style="background-color: #863acf;color: #fff;font-weight: 400;padding: 5px;border-radius: 3px;cursor: pointer;display: inline-block;" 
            (click)="onTogglePopup()">Cancel</span>
    </div>
    <div class="col text-right">
      <span style="background-color: #863acf;color: #fff;font-weight: 400;padding: 5px;border-radius: 3px;cursor: pointer;display: inline-block;" 
            (click)="onApplyFilter()">Apply</span>
    </div>
  </div>

  <div class="row mb-2" *ngIf="filterType === 'assigned'">
    <div class="col">
      <div class="form-group">
        <input class="form-control" type="text" autocomplete="off"
            placeholder="⌕ search agents" (input)="onSearch($event.target.value)">
    </div>
    </div>
  </div>

  <div class="form-group form-check" *ngFor="let item of getDisplayItems()">
    <input type="checkbox" class="form-check-input" id="is_checked_{{item.id}}" [(ngModel)]="item.checked">&nbsp;
    <label class="form-check-label" for="is_checked_{{item.selectedIds}}">
      <span style="font-weight: 400;">{{item.selectedNames}}</span>
    </label>
  </div>

  <!-- <div class="row" *ngIf="filteredItems.length > defaultItemCount">
    <div class="col">
      <span style="background-color: #863acf;color: #fff;font-weight: 400;padding: 5px;border-radius: 3px;cursor: pointer;display: inline-block;" 
            (click)="showMore()">Show More</span>
    </div>
  </div> -->

  <div class="row">
    <div class="col">
      <span style="background-color: #863acf;color: #fff;font-weight: 400;padding: 5px;border-radius: 3px;cursor: pointer;display: inline-block;" 
            (click)="onTogglePopup()">Cancel</span>
    </div>
    <div class="col text-right">
      <span style="background-color: #863acf;color: #fff;font-weight: 400;padding: 5px;border-radius: 3px;cursor: pointer;display: inline-block;" 
            (click)="onApplyFilter()">Apply</span>
    </div>
  </div>
</div>

  